import { render, staticRenderFns } from "./TokenTransactionsTable.vue?vue&type=template&id=34127a13&scoped=true&"
import script from "./TokenTransactionsTable.vue?vue&type=script&lang=js&"
export * from "./TokenTransactionsTable.vue?vue&type=script&lang=js&"
import style0 from "./TokenTransactionsTable.vue?vue&type=style&index=0&id=34127a13&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34127a13",
  null
  
)

export default component.exports